// import our vuex state management
import store from '@/store';

export default {
  
  data() {

    return {
      url: `${window.location.protocol}//${window.location.hostname}${store.getters.getBaseUrl}`
    }

  },


  methods: {

    shareContent(network, title, currentUrl = true) {


      if (currentUrl) {
        this.url = window.location.href;
      }

      if (network === 'twitter') {
        this.shareOnTwitter(title);
      } else if(network === 'facebook') {
        this.shareOnFacebook();
      } else if (network === 'linkedin') {
        this.shareOnLinkedIn(title);
      }

    },

    shareOnTwitter(title) {

      const shareCopy = encodeURIComponent(`${title} ${this.url} via @Oracle`);
      window.open(`https://twitter.com/intent/tweet?text=${shareCopy}`);

    },

    shareOnFacebook() {

      const url = encodeURIComponent(this.url);
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);

    },

    shareOnLinkedIn(title) {

      const shareCopy = encodeURIComponent(`${title}`);
      const url = encodeURIComponent(this.url);
      window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${shareCopy}`);

    }



  },
};
